import { CurrencyEuroIcon } from "@heroicons/react/20/solid";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import { XCircleIcon } from "@heroicons/react/24/solid";
import clsx from "clsx";
import type { ReactNode } from "react";

import { invoiceStatusId } from "~/modules/billing/api/invoiceStatus/invoiceStatusId.ts";
import type { InvoiceStatusId } from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";


export const getInvoiceStatusIcon = (statusId: InvoiceStatusId, className?: string, isOverdue?:boolean): ReactNode => {
	switch (statusId) {
		case invoiceStatusId.Draft:
		case invoiceStatusId.AwaitingApproval:
		case invoiceStatusId.Approved:
			return <PencilSquareIcon className={clsx(" text-primary-300", className)} />;
		case invoiceStatusId.SentToClient:
			return <><CurrencyEuroIcon className={clsx(" text-yellow-500", className)} />{isOverdue && <span className="text-base	 font-bold text-danger-500">!</span>}</>;
		case invoiceStatusId.Paid:
			return <CurrencyEuroIcon className={clsx(" text-success-500", className)} />;
		case invoiceStatusId.Reversed:
			return <XCircleIcon className={clsx("text-danger-500", className)} />;
		default:
			return null;
	}
};